var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"prepare-rank"},[_c('div',{staticClass:"echarts-warpper"},[(_vm.xAxisData.length)?_c('e-charts',{ref:"echarts",style:('min-height: 300px;height:' + (_vm.xAxisData.length * 50 + 70) + 'px'),attrs:{"options":_vm.options}}):_c('not-data')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }